import { Instance } from 'mobx-state-tree'
import { ZogoCredentialModelBase } from './ZogoCredentialModel.base'

/* The TypeScript type of an instance of ZogoCredentialModel */
export interface ZogoCredentialModelType extends Instance<typeof ZogoCredentialModel.Type> {}

/* A graphql query fragment builders for ZogoCredentialModel */
export {
  selectFromZogoCredential,
  zogoCredentialModelPrimitives,
  ZogoCredentialModelSelector
} from './ZogoCredentialModel.base'

/**
 * ZogoCredentialModel
 */
export const ZogoCredentialModel = ZogoCredentialModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
